import { element, only } from './definition';
import { look, typeface } from './styleTokens';

// The cart page's own content: the lines a shopper can change, the order note, the estimated total and Check
// out, or the empty cart with collections to start from. It is offered only on the cart page.

/** The cart, as the /cart page draws it. */
export const cartContentsElement = element('cart-contents', {
  label: 'Cart',
  description: 'The shopper’s cart: lines to change, an order note, the estimated total and Check out.',
  category: 'Other',
  icon: 'shopping-cart',
  binds: only(['cart']),
  props: [],
  defaults: { props: {}, styles: look({ width: '100%', fontFamily: typeface('body') }) }
});
